/**
 * Changes the input field of the form
 *
 * @param  {form} form The new text of the input field
 *
 * @return {object}    An action object with a type of CHANGE_USERNAME
 */
import {
  SAVE,
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_PERSONAL_ACCIDENT_STATE,
  RESET_PERSONAL_ACCIDENT_INJURY_STATE,
  RESET_PERSONAL_ACCIDENT_INJURY_LEAVE_PERMANENTLY_STATE,
  RESET_PERSONAL_ACCIDENT_INJURY_RESULT_STATE,
} from './constants';

export function saveFormData(form) {
  return {
    type: SAVE,
    payload: form,
  };
}

export function loadFormData(form) {
  return {
    type: LOAD,
    payload: form,
  };
}

export function handleFormDataChange(propertyName, value) {
  return {
    type: VALUE_CHANGED,
    propertyName,
    value,
  };
}

export function nextSlide(errors) {
  return {
    type: NEXT,
    errors,
  };
}

export function resetFormData() {
  return {
    type: RESET,
  };
}

export function resetFormClaimRelatedToPersonalAccident() {
  return {
    type: RESET_PERSONAL_ACCIDENT_STATE,
  };
}

export function resetFormClaimRelatedToLossOfLife() {
  return {
    type: RESET_PERSONAL_ACCIDENT_INJURY_STATE,
  };
}

export function resetFormClaimRelatedInjuryLeaveYouPermanently() {
  return {
    type: RESET_PERSONAL_ACCIDENT_INJURY_LEAVE_PERMANENTLY_STATE,
  };
}

export function resetFormClaimRelatedInjuryResult() {
  return {
    type: RESET_PERSONAL_ACCIDENT_INJURY_RESULT_STATE,
  };
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.PersonalAccident/actions.js